var _circle, _circle2, _path, _path2, _path3, _circle3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddOpportunity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F8FEF4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    stroke: "#4CBC18"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 36.6963V30.057H25.891V42.6404C24.6303 42.8765 23.3299 43 22.0006 43C16.1243 43 10.8116 40.5863 7 36.6963ZM26.8624 42.4344V30.057C26.8624 29.5013 26.4274 29.0508 25.891 29.0508H22.5554V19.5358L36 22.8247V37.6533C34.9269 38.6137 33.7545 39.4653 32.5 40.191V34H29V41.8053C28.3036 42.0514 27.5903 42.2619 26.8624 42.4344ZM8.28926 21.1933L10.3376 19.9684V29.0508H21.584V13.243L23.7651 11.9387C23.8766 11.8719 23.958 11.762 23.9913 11.6332C24.0246 11.5043 24.0072 11.367 23.9429 11.2515C23.8784 11.136 23.7723 11.0517 23.6479 11.0172C23.5235 10.9826 23.391 11.0006 23.2794 11.0673L7.80356 20.322C7.57139 20.4608 7.49174 20.7687 7.62579 21.0092C7.75985 21.2497 8.0571 21.3322 8.28926 21.1933ZM12.4787 20.3552H15.4751V22.1826H12.4787V20.3552ZM12.4787 25.0162V23.1887H15.4751V25.0162H12.4787ZM19.4429 25.0162H16.4465V23.1887H19.4429V25.0162ZM19.4429 20.3552V22.1826H16.4465V20.3552H19.4429ZM32.5 26V30.5H29V26H32.5ZM17.8339 33.3187H22.5664V38H17.8339V33.3187ZM10.3245 33.3187H15.057V38H10.3245V33.3187Z",
    fill: "#CECECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L4.44532 2.55468L7 3.5L4.44532 4.44532L3.5 7L2.55468 4.44532L0 3.5L2.55468 2.55468L3.5 0Z",
    fill: "#4CBC18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7L15.1752 8.82477L17 9.5L15.1752 10.1752L14.5 12L13.8248 10.1752L12 9.5L13.8248 8.82477L14.5 7Z",
    fill: "#4CBC18"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 9,
    r: 8.5,
    fill: "#4CBC18",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3907 13V5H35.6446V13H34.3907ZM31 9.63436V8.38326H39V9.63436H31Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOpportunity);
export default __webpack_public_path__ + "static/media/add-opportunity.43bb337dbda3700d4e6f461d17954604.svg";
export { ForwardRef as ReactComponent };